// extracted by mini-css-extract-plugin
module.exports = {"noDataFound":"NoDataMessage_noDataFound__2Kpwq"};